<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <!-- Logo y descripción -->
        <div class="footer-section">
          <img src="@/assets/images/jamrock-logo-iguana.webp" alt="Jamrock Logo" class="footer-logo img-fluid">
        </div>

        <!-- Links útiles -->
        <div class="footer-section">
          <h4 class="footer-subtitle">Enlaces Útiles</h4>
          <ul class="footer-links">
            <li><a class="footer-link text-black" href="/productos">Productos</a></li>
            <li><a class="footer-link text-black" href="/mi-cuenta">Mi Cuenta</a></li>
            <li><a class="footer-link text-black" href="https://instagram.com/jamrockgrowshop" target="_blank">Contacto</a></li>
          </ul>
        </div>

        <!-- Contacto -->
        <div class="footer-section">
          <h4 class="footer-subtitle">Contacto</h4>
          <ul class="footer-contact">
            <li>
              <FaIcon name="map-marker-alt" />
              <a href="https://maps.app.goo.gl/xiX2by2YXpqEX8qd9" target="_blank" class="contact-link">
                Riobamba 785, Merlo Buenos Aires, Argentina
              </a>
            </li>
            <li>
              <FaIcon name="instagram" brand />
              <a href="https://instagram.com/jamrockgrowshop" target="_blank" class="contact-link">
                @jamrockgrowshop
              </a>
            </li>
            <li>
              <FaIcon name="envelope" />
              <a href="mailto:jamrockgrowshop@hotmail.com" class="contact-link">
                jamrockgrowshop@hotmail.com
              </a>
            </li>
          </ul>
        </div>

        <!-- Redes sociales -->
        <div class="footer-section">
          <h4 class="footer-subtitle">Síguenos</h4>
          <div class="social-links">
            <a href="https://instagram.com/jamrockgrowshop" class="social-link" aria-label="Instagram">
              <FaIcon name="instagram" brand />
            </a>
            <a href="https://www.facebook.com/jamrockgrowshop" class="social-link" aria-label="Facebook">
              <FaIcon name="facebook" brand />
            </a>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p class="text-black">&copy; {{ currentYear }} Jamrock Growshop. Todos los derechos reservados.</p>
      </div>
      <div class="dev">
        <p class="text-black">Desarrollado por <a href="https://permaculture.ar" target="_blank" class="dev-link">
          <img src="@/assets/images/permaculture-logo.svg" alt="Permaculture Logo" class="dev-logo">
        </a></p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { onMounted } from 'vue';
import ScrollReveal from 'scrollreveal';

const currentYear = new Date().getFullYear();

onMounted(() => {
  // Inicializar ScrollReveal para el footer
  initializeFooterAnimations();
});

const initializeFooterAnimations = () => {
  const sr = ScrollReveal({
    distance: '30px',
    duration: 800,
    delay: 100,
    origin: 'bottom',
    reset: false
  });

  // Animar elementos del footer
  sr.reveal('.footer-logo', {
    origin: 'top',
    delay: 200
  });

  sr.reveal('.footer-section', {
    origin: 'bottom',
    interval: 150,
    delay: 200
  });

  sr.reveal('.footer-bottom', {
    origin: 'bottom',
    delay: 300
  });

  sr.reveal('.dev', {
    origin: 'bottom',
    delay: 400
  });
};
</script>

<style scoped>
.footer {
  background-color: var(--footer-bg);
  color: var(--black-color-2);
  padding: 4rem 0 1rem 0;
  border-top: 1px solid var(--footer-border);
}

.footer-logo {
  width: 250px;
  margin-bottom: 1.5rem;
  transition: transform 0.3s ease;
}

.footer-logo:hover {
  transform: scale(1.05);
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2.5rem;
  margin-bottom: 3rem;
}

.footer-section {
  padding: 0 1rem;
}

.footer-subtitle {
  color: var(--black-color-2);
  font-size: 1.1rem;
  margin-bottom: 1.2rem;
  font-weight: 600;
  position: relative;
  padding-bottom: 10px;
}

.footer-subtitle::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  height: 3px;
  width: 40px;
  background-color: var(--primary-color);
}

.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 0.8rem;
}

.footer-link {
  color: var(--footer-link);
  text-decoration: none;
  transition: color 0.2s ease, transform 0.2s ease;
  display: inline-block;
  font-size: 0.95rem;
}

.footer-link:hover {
  color: var(--primary-color);
  transform: translateX(3px);
}

.footer-contact {
  list-style: none;
  padding: 0;
}

.footer-contact li {
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.7rem;
}

.footer-contact i {
  color: var(--primary-color);
  font-size: 1rem;
  width: 20px;
  text-align: center;
}

.contact-link {
  color: var(--black-color-2);
  text-decoration: none;
  font-size: 0.95rem;
  transition: color 0.2s ease;
}

.contact-link:hover {
  color: var(--primary-color);
}

.social-links {
  display: flex;
  gap: 1.2rem;
}

.social-link {
  color: var(--black-color-2);
  font-size: 1.7rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.social-link:hover {
  color: var(--primary-color);
  transform: translateY(-3px);
}

.footer-bottom {
  border-top: 1px solid var(--footer-border);
  padding-top: 1.5rem;
  text-align: center;
  color: var(--black-color-2);
  font-size: 0.9rem;
}

.dev {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.dev p {
  font-size: 0.85rem;
  color: var(--black-color-2);
  display: flex;
  align-items: center;
  gap: 5px;
}

.dev-link {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  transition: transform 0.3s ease;
}

.dev-link:hover {
  transform: scale(1.05);
}

.dev-logo {
  max-width: 120px;
  height: auto;
  margin-left: 5px;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
  }

  .footer-section {
    text-align: center;
    padding: 0 0.5rem;
  }

  .footer-subtitle::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .footer-contact li {
    justify-content: center;
  }

  .social-links {
    justify-content: center;
  }

  .footer {
    padding: 3rem 0 1rem 0;
  }
}
</style>
